import { TokenClaims } from '@azure/msal-common/browser';

export interface TokenResponse {
    access_token: string;
    expires_in: number;
    refresh_expires_in: number;
    refresh_token: string;
    token_type: string;
    id_token: string;
    session_state: string;
    scope: string;
}

export interface WanUserModel {
    global: string;
    xds: string;
}

export interface DinamicConfig
{
    tokenUri: string;
    refreshTokenUri: string;
    clientId: string;
    loginType: string;
}

export interface IUser {
    email: string;
    name: string;
    wam_user: WanUserModel;
}

export interface IUserRole {
    success: boolean;
    data: IResponseData;
}

export interface IResponseData {
    usuario: IUserData;
    role: Array<IRole>;
}

export interface IUserData {
    cd_usuario: string;
    ds_nome: string;
    ds_email: string;
    fl_ativo: boolean;
    dt_ultimo_login: string;
    cd_usuario_cadastro: string;
}

export interface IRole
{
    id_role: number;
    ds_role: string;
    dt_inclusao: string;
}

export interface IUsersRoles
{
    cd_usuario: string;
    id_role: number;
    dt_inclusao: string;
}

export interface IApiEnvelope<T = void> {
    content: any;
    data: T;
    success: boolean;
    error: IApiError;
}

export interface IPaginated<T = void> {
    content: any;
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
    data: T;
}

export interface IPaginatedFilters {
    paginationSize?: string;
    paginationValue?: string;
    columnKey?: string;
    sortingDirection?: string;
    query?: string;
  }

export interface IApiError {
    titulo: string;
    detalhe: string;
    dataHora: Date;
    mensagemParaUsuarioFinal: string;
}

export interface ISolicitacaoEnvio {
    iD_CHASSI: number;
    dT_SOLIC: string;
    tP_MANUT: string;
    lote: number; 
    observ: string; 
}

//TABLES
export interface IAcessosUsuarios {
    cd_usuario: string;
    ds_nome: string;
    ds_email: string;
    fl_ativo: string;
    dt_ultimo_login: string;
    admin_role: string;
    renavam_role: string;
    renave_role: string;
}

//RENAVE
export interface IViaCEP{
    cep: string;
    logradouro: string;
    complemento: string;
    bairro: string;
    localidade: string;
    uf: string;
    ibge: string;
    gia: string;
    ddd: string;
    siafi: string;
    erro?: boolean;
}

export interface IMinhaReceita{
    cep: string;
    uf: string;
    bairro: string;
    municipio: string;
    descricao_tipo_de_logradouro: string;
    logradouro: string;
    complemento: string;
    numero: string;
    razao_social: string;
    codigo_municipio: string;
}

export interface IRenave{
    nr_chassi: string;
    id_estoque?: number;
    dt_operacao: string;
    fl_veiculo_acabado: string;
    id_estado: number;
    id_operacao: number;
    cd_responsavel_operacao: string;
    ds_observacao: string;
}

export interface IRenaveEntry{
    chassi: string;
    cpfOperadorResponsavel?: string;
    dataEntradaEstoque: string;
    dataHoraMedicaoHodometro: string;
    quilometragemHodometro: number;
}

export interface IRenaveCancel{
    idEstoque: number;
    cpfOperadorResponsavel?: string;
    dataCancelamentoEntradaEstoque?: string;
    dataCancelamentoSaidaEstoque?: string;
}

export interface IRenaveExitRequest{
    idEstoque: number;
    tipoBeneficioTributario: string;
    chaveNotaFiscal: string;
    dataVenda?: string;
    valorVenda: number;
    comprador: IRenaveBuyer;
    emailEstabelecimento: string;
}

export interface IRenaveBuyer{
    nome: string;
    email: string;
    endereco: IRenaveAddress;
    tipoDocumento: string;
    numeroDocumento: string;
}

export interface IRenaveAddress{
    cep: string;
    logradouro: string;
    numero: string;
    complemento: string;
    bairro: string;
    codigoMunicipio: number;
}

export interface IRenavePDF{
    numeroAtpv?: string;
    pdfAtpvBase64?: string;
    xmlAtpvBase64?: string;
    numeroTermoSaidaEstoque?: number;
    pdfBase64?: string;
}

export interface IRenaveMock{
    chassi: string;
}

export interface IOperacaoRenave{
    viN_CODE: string;
    tipomanutencao: string;
    numerolote: number;
    observacaochassi?: string;
    condicaoveiculo: string;
    dataentradaestoque: string;
    chavenotafiscal: string;
    emailnfe: string;
    endereco: string;
    numero: string;
    complemento?: string;
    bairro: string;
    cep: string;
    municcodigoserpro: string;
    razaosocial: string;
    tipodocumento: string;
    numerodocumento: string;
    datacancelamento?: string;
    datavenda?: string;
    valorvenda: number;
    dT_MOVIMENTO: string;
    status: string;
}
//RENAVAM

export interface IMarcaModelo{
    cd_modelo: number;
    ds_modelo: string;
    ds_carroceria?: string;
    id_marca?: number;
    ds_marca?: string;
    id_segmento?: number;
    ds_segmento?: string;
    id_tracao?: number;
    ds_tracao?: number;
    id_combustivel?: number;
    ds_combustivel?: string;
    id_chassi?: number;
    ds_pbt?: string;
    ds_cmt?: string;
    ds_potencia?: string;
    dt_cadastro?: Date;
    dt_atualizacao?: Date;
    cd_categoria?: string;
    ds_categoria?: string;
    cd_aplicacoes?: string[];
    vl_comprimento?: number;
    vl_bateria?: number;
}

export interface IMarca{
    id_marca: number;
    ds_marca: string;
}

export interface IAplicacao{
    id_aplicacao: number;
    ds_aplicacao: string;
}

export interface ICategoria{
    cd_categoria: string;
    ds_categoria: string;
}

export interface ICombustivel{
    id_combustivel: number;
    ds_combustivel: string;
}

export interface IChassi{
    id_chassi: number;
    ds_chassi: string;
}

export interface ISegmento{
    id_segmento: number;
    ds_segmento: string;
}

export interface ITracao{
    id_tracao: number;
    ds_tracao: string;
}

export interface ICodigosRenavam{
    tipO_COD: number;
    coD_ORIGINAL: string;
    coD_RENAVAM: string;
    denoM_CURTA?: string;
    useR_INSERT?: string;
    dT_INSERT?: string;
    useR_UPDATE?: string;
    dT_UPDATE?: string;
    ds_categ_renavam?: string;
}

export const codigoCategoria: { [key: number]: string; } = {
  1: "COR",
  2: "TIPO DE COMPRADOR",
  3: "TIPO DE VEÍCULO",
  4: "TIPO DE VENDA",
  5: "PAÍS DE ORIGEM",
  6: "COMBUSTÍVEL",
  7: "CARROCERIAS",
  8: "RESTRIÇÕES"
};

export interface INotificacao{
    registro: number;
    usuario?: string;
    nome: string;
    email?: string;
    empresa?: string;
}

export interface IRetornoEnvio{
    nu_chassi: string;
    nr_lote: number;
    ds_mensagem: string;
    dt_retorno: Date;
}

export enum AppRoles {
    isAdmin = "BRSA_RENA_ADMIN_ACCESS",
    isRenavam = "BRSA_RENA_RENAVAM_ACCESS",
    isRenave = "BRSA_RENA_RENAVE_ACCESS"
}

export interface CustomTokenClaims extends TokenClaims {
  userid?: string | null;
}